import React, { Component } from "react";
import classNames from "classnames";
import "./style.scss";
import { withRouter } from "react-router-dom";
import { removeTransition } from "../../redux/actions/actions";
import { connect } from "react-redux";

class PageCurtain extends Component {
  portalElement = null;
  timeoutnull=null;

  constructor(props) {
    super(props);
    this.state = {
      next: 0,
      play: true,
      transtions:[
        {
          className: "",
          duration: 100
        },
        {
          className: "transition__slide",
          duration: 1000,
        },
        {
          className: "transition__open-curtains",
          duration: 1000,
          redirect: true
        }
      ]
    };
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutnull)
    //document.body.removeChild(this.portalElement);
  }

  timeout(transition) {
    if (transition) {
      this.timeoutnull=setTimeout(() => {
        this.setState({
          next: this.state.next + 1,
          play: this.props.play
        });
      }, transition.duration);
    }
  }
  goPage(){
    let {history,linktype,path}=this.props;
    if(window.location.pathname===path){
      return null;
    }
    if (linktype === "internal") {
      history.push(path);
    } else {
      window.open(path);
    }
  }
  renderTransition() {
    let transtions=this.state.transtions;
    const currentTransition = transtions[this.state.next];
    if (currentTransition && this.state.play) {
      const extraCurtainClasses = transtions
          .filter((item, index) => index <= this.state.next)
          .map(item => item.className)
          .join(" "),
        pageCurtainClasses = `page-curtain ${extraCurtainClasses}`,
        curtainClasses = classNames("curtain", {
          "from-right": this.props.fromRight === true
        }),
        curtainLeftClasses = "left",
        curtainRightClasses = "right";
      this.timeout(currentTransition);
      document.body.className = this.state.next > 0 ? extraCurtainClasses : "";
      if (currentTransition.redirect === true) {
        this.goPage();
      }
        let backgroundColorStyle = {
          backgroundColor: this.props.curtainBackgroundColor || "#131313"
        };


        return (
          <div className={pageCurtainClasses}>
            <h2 dangerouslySetInnerHTML={{ __html: this.props.title }}></h2>
            <div className={curtainClasses}>
              <div className={curtainLeftClasses} style={backgroundColorStyle} />
              <div className={curtainRightClasses} style={backgroundColorStyle} />
            </div>
          </div>
        );


    } else {
      document.body.className = "";
      this.props.removeTransition(this.props.name, this.props.path);
      //console.log(this.props);
      // if (this.props.linktype === "internal") {
      //   this.props.history.push(this.props.path);
      // } else {
      //   window.open(this.props.path);
      // }
      return null;
    }
  }

  render() {
    return this.renderTransition();
  }
}

const mapDispatchToProps = {
  removeTransition: removeTransition
};

export default withRouter(connect(null, mapDispatchToProps)(PageCurtain));
